<template>
    <form class="formblock shadowed" :class="'formblock-'+content.pageslug" @submit.prevent="sendform()">
        <description :content="content" :websiteid="websiteid" :readonly="readonly" class="mb-4 text-muted"/>
        <div v-for="meta, key in blockmeta.meta" class="formrow" :class="'formrow-'+key">
            <label>{{key}}:</label>
            <input v-if="meta == 'Text'" type="text" v-model="pagesettings[key]" class="inputfield"/>
            <input v-if="meta == 'Number'" type="number" v-model="pagesettings[key]" class="inputfield"/>
            <input v-else-if="meta == 'Email'" type="email" v-model="pagesettings[key]" class="inputfield" />
            <input v-else-if="meta == 'String'" type="text" v-model="pagesettings[key]" class="inputfield" />
            <input v-else-if="meta == 'File'" type="file" class="inputfield inputfilefield" ref="file" v-on:change="handleFileUpload()"/>
            <textarea v-else-if="meta == 'Area'" rows="3" v-model="pagesettings[key]" class="inputfield" ></textarea>
        </div>
        <button class="btn btn-primary" type="submit">Verzenden</button><loader v-if="loading"/>
        <transition name="fade">
            <alert-bar class="mt-4" v-if="msgtext" v-bind:class="msgclass">{{msgtext}}</alert-bar>
        </transition>
    </form>
</template>

<script>
import Description from '../content/Description.vue';
import ItemAdder from '../app/ItemAdder.vue';
import Modal from '../modal/Modal.vue';
import AlertBar from '../form/Alert.vue';
import Loader from '../ui/Loader.vue';

import { userService } from '../../services/user.service.js';
import { authHeader } from '../../services/auth-header.js';

import axios from 'axios';

export default {
    components: {
        Modal,
        Description,
        AlertBar,
        Loader
    },
    props: {
        pageid: String,
        websiteid: String,
        readonly: Boolean,
        feature: String,
        sitedata: Object,
        content: Object
    },
    computed: {
    },
    data: function() {
        return{
            msgtext: '',
            msgclass: 'error',
            showModal: false,
            pages: {},
            blockmeta: '',
            pagesettings: {},
            file: '',
            loading: false
        }
    },
    methods: {
        handleFileUpload(){
            this.file = this.$refs.file[0].files[0];
        },
        sendform(){

            this.loading = true;
            var myJSON = JSON.stringify(this.pagesettings);

            if(Object.keys(this.pagesettings).length > 0){
                let formData = new FormData();
                formData.append('websiteid', this.websiteid)
                formData.append('content', myJSON)
                if (this.$route.params.pageslug){
                    formData.append('pagename', this.$route.params.pageslug)
                } else {
                    formData.append('pagename', this.sitedata.name)
                }
                formData.append('attachment', this.file)

                axios.post(process.env.VUE_APP_ROOT_API+'/settings/contactform', formData)
                .then(
                    response => {
                        console.log(response.data)
                        if (response.data.success == false){
                            this.msgtext = response.data.error_message
                        } else {
                        this.msgclass = 'success'
                        this.msgtext = 'We hebben je bericht verzonden'
                        }
                        this.loading = false
                    },
                    error => {
                        console.log(error.data)
                        this.msgtext = error,
                        this.loading = false
                    }
                )
            } else {
                this.msgclass = 'error'
                this.msgtext = 'Vul de velden in'
                this.loading = false
            }
        }
    },
    mounted(){
        if(this.content.blockstyle == "Contactform") {
            this.blockmeta = {
                "name": "Contactform",
                "type": "form",
                "meta": {
                    "Naam": "Text",
                    "Email": "Email",
                    "Telefoonnummer": "String",
                    "Bericht": "Area"
                }
            }
        } else {
            this.blockmeta = this.sitedata.features.find(obj => {
                return obj.name === this.content.blockstyle
            })
        }
    }
}
</script>